var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useApplicationContext } from "../../context/application-context";
import { setAuthorization, setAuthorizationProctoring } from "../../api-client";
import authService from "../../api-client/services/auth";
import { SpinLoader } from "../../components/loaders/spin-loader";
import { message } from "antd";
import { CookiesExistence } from "../../submodules/Inventory-Module-Types/src/utils/storage";
import Cookies from "js-cookie";
import { useCrossOrigin } from "../cross-origin";
import AccessDenied from "../../components/access-denied";
const PrivateRoute = ({ children, roles, }) => {
    const metaData = useCrossOrigin();
    const { auth, user, setUser, setAuth, tenantSettings } = useApplicationContext();
    const [showLoader, setShowLoader] = useState(true);
    useEffect(() => {
        if (!auth.userExists) {
            getUserLoggedInStatus();
        }
        else {
            setShowLoader(false);
        }
    }, []);
    const getUserLoggedInStatus = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const token = sessionStorage.getItem("token");
            const userId = sessionStorage.getItem("userId");
            setAuthorization(token);
            setAuthorizationProctoring(token);
            const response = yield authService.getAuthenticatedUser(token, userId);
            if (response.data) {
                const userData = response.data;
                if (!auth.userExists) {
                    setAuth({
                        userExists: true,
                        userLoading: false,
                    });
                }
                if (userData) {
                    setUser(userData);
                }
                setShowLoader(false);
            }
            else {
                const cookieData = CookiesExistence("redirect-on-app", true);
                message.error("It seems that you have already completed the interview.");
                setAuth({
                    userExists: false,
                    userLoading: false,
                });
                setShowLoader(false);
                if (cookieData.isExist) {
                    Cookies.remove("redirect-on-app");
                    setTimeout(() => {
                        let redirectURL = cookieData.data + "/interview-profile";
                        window.open(redirectURL, "_self");
                    }, 2000);
                }
            }
        }
        catch (error) {
            console.error("Error while fetching user in OIDC", error);
        }
    });
    if (showLoader) {
        return (_jsxs("div", Object.assign({ style: { width: "100vw", height: "100vh", overflow: "hidden" } }, { children: [_jsx(SpinLoader, { logoHeight: "300", logoWidth: "300", logo: tenantSettings.tenantConfig.brandLogo.whiteBgLogo }), ";"] })));
    }
    const userHasRequiredRole = user && user.role && roles.includes(user.role) ? true : false;
    if (!auth.userExists) {
        return _jsx(Navigate, { to: { pathname: "/not-found" } });
    }
    if (auth.userExists && !userHasRequiredRole) {
        return _jsx(AccessDenied, {});
    }
    return _jsx(_Fragment, { children: children });
};
export default PrivateRoute;
